import React, { useState, useRef, useEffect } from 'react';

const basicShades = [
// Vermelhos pastel
    '#f2c8c8', '#f28a8a', '#d45555',

    // Verdes pastel
    '#ccefcf', '#87cb8b', '#59a755',

    // Azuis pastel
    '#c9e3f5', '#73b9f3', '#4ca2e4',

    // Amarelos pastel
    '#f5efb1', '#f5e65c', '#f0b800',

    // Cinzas suaves (substituindo pretos)
    '#bdbdbd', '#9e9e9e', '#757575', // Cinza neutro, sem muita saturação — quase sem efeito visível

    // Marrons pastel
    '#eedcc8', '#d7a679', '#c5956b',
];


const ColorPicker = ({ cor, setCor }) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        if (open) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [open]);

    return (
        <div className="p-colorpicker" ref={dropdownRef}>
            <button
                type="button"
                className="p-colorpicker-trigger"
                style={{
                    backgroundColor: cor ? `#${cor}` : '#fff',
                    color: cor?.toUpperCase() === 'FFFFFF' ? '#000' : '#fff',
                }}
                onClick={() => setOpen(!open)}
                aria-label="Toggle color picker"
            >
                {cor ? `#${cor}` : 'Selecione'}
                <span className="p-colorpicker-icon">▼</span>
            </button>

            {open && (
                <div className="p-colorpicker-panel">
                    {basicShades.map((color) => {
                        const cleanColor = color.replace('#', '');
                        return (
                            <button
                                key={color}
                                type="button"
                                onClick={() => {
                                    setCor(cleanColor);
                                    setOpen(false);
                                }}
                                className={`p-colorpicker-color ${cor === cleanColor ? 'selected' : ''}`}
                                style={{
                                    backgroundColor: color,
                                    backgroundImage: 'none',
                                    width: '30px',
                                    height: '30px',
                                    borderRadius: '4px',
                                    border: cor === cleanColor ? '2px solid #007ad9' : '1px solid #ced4da',
                                    boxShadow: cor === cleanColor ? '0 0 4px #007ad9' : 'none',
                                    cursor: 'pointer',
                                }}
                                aria-label={`Cor ${color}`}
                            />
                        );
                    })}
                </div>
            )}

            <style>{`
                .p-colorpicker {
                  position: relative;
                  width: 220px;
                  font-family: 'Segoe UI', Tahoma, sans-serif;
                }

                .p-colorpicker-trigger {
                  width: 100%;
                  padding: 10px;
                  border: 1px solid #ced4da;
                  border-radius: 4px;
                  cursor: pointer;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  font-weight: 600;
                  user-select: none;
                }

                .p-colorpicker-icon {
                  font-size: 12px;
                  margin-left: 8px;
                }

                .p-colorpicker-panel {
                  position: absolute;
                  top: calc(100% + 6px);
                  left: 0;
                  width: 100%;
                  background: #fff;
                  border: 1px solid #ced4da;
                  border-radius: 4px;
                  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                  display: grid;
                  grid-template-columns: repeat(6, 1fr);
                  gap: 4px;
                  padding: 8px;
                  z-index: 1000;
                }

                .p-colorpicker-color.selected {
                  border: 2px solid #007ad9;
                  box-shadow: 0 0 4px #007ad9;
                }
            `}</style>
        </div>
    );
};

export default ColorPicker;
